import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Datatable from "../../ExtraComponents/ReusableTable2";
import {
  getAllQuotes,
  deleteContract,
  createContract,
  downloadContract
} from "../../ReduxStore/Slice/Contract/contractSlice";
import { useDispatch } from "react-redux";
import { PenLine, Trash2 } from "lucide-react";
import { DateConvert, DateConvertWithTime ,cleanHtmlEntities } from "../../Utils/CommonFun";
import Swal from "sweetalert2";
import axios from "axios";
import ReactPaginate from "react-paginate";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs"
import { DatePicker, Space, theme } from 'antd';
import * as Config from "../../Utils/Config";



const AllQuotes = () => {
  const { state } = useLocation();
  const [isStateReady, setIsStateReady] = useState(false);

  // console.log("state ", state)
  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const userDetails = JSON.parse(localStorage.getItem("details"));


  const [allQuoteData, setAllQuoteData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [InputValue, setInputValue] = useState('');

  const [activeTab, setActiveTab] = useState("");
  const [contractTiles, setContractTiles] = useState("");
  const [range, setRange] = useState(null);

  // console.log("allQuoteData", allQuoteData)


  // useEffect(() => {
  //   if (state?.activeTab && state?.contractTiles) {
  //     setActiveTab(state.activeTab);
  //     setContractTiles(state.contractTiles);

  //     if (Array.isArray(state.range)) {
  //       setRange([
  //         dayjs(state.range[0]),
  //         dayjs(state.range[1])
  //       ]);
  //     }
  //   }
  // }, [state]);


  useEffect(() => {
    if (state?.activeTab && state?.contractTiles) {
      setActiveTab(state.activeTab);
      setContractTiles(state.contractTiles);

      if (Array.isArray(state.range)) {
        setRange([
          dayjs(state.range[0]),
          dayjs(state.range[1])
        ]);
      }

      // 🔑 mark state ready
      setIsStateReady(true);
    }
  }, [state]);


  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  }

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])


  useEffect(() => {
    if (state?.activeTab === undefined && state?.contractTiles === undefined) {
      AllQuote();
    } else {
      if (!isStateReady) return;
      AllQuote();
    }

  }, [currentPage, pageSize, InputValue, activeTab, range, contractTiles]);

  const handleTabChange = (event) => {
    setActiveTab(event.target.value);
  };

  const handleContratTiles = (event) => {
    setContractTiles(event.target.value)
  }



  const AllQuote = async () => {
    let req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue, filter: activeTab, contractTiles: contractTiles };

    console.log("req ", req)

    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }

    await dispatch(getAllQuotes(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllQuoteData(response.data);
          setTotalRecords(response?.pagination?.total)

        } else {
          setAllQuoteData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  const handleResendContract = async (row) => {
    // console.log("row handleResendContract", row);
    if (row.resend_contract_exist_data != null) {
      // Confirmation dialog
      Swal.fire({
        title: "Are you sure?",
        html: `<div>
             <div>Contract is already sent!</div>
             <div>Do you want to resend this contract?</div>
           </div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Resend",
        cancelButtonText: "Cancel"
      }).then(async (result) => {
        if (result.isConfirmed) {

          // console.log("row.resend_contract_exist_data", JSON.parse(row.resend_contract_exist_data));
          let exist_send_data = JSON.parse(row.resend_contract_exist_data);

          // console.log("exist_send_data", exist_send_data.email_template_details);
          // console.log("exist_send_data clientid", exist_send_data.clientid);


          const req = {
            id: Number(exist_send_data.id),
            step: 4,
            mail_to: exist_send_data.mail_to,
            subject: exist_send_data.subject,
            template_id: exist_send_data.template_id,
            clientid: exist_send_data.clientid,
            ContractOwner: userDetails.id,
            agent_id: exist_send_data.agent_id,
            director_letter: exist_send_data.director_letter,
            self_assessment: exist_send_data.self_assessment,
            payment_type: exist_send_data.payment_type,
            cc_to: exist_send_data.cc_to || "",
            bcc_to: exist_send_data.bcc_to || "",
            email_template_details: exist_send_data.email_template_details

          }

          // console.log("req", req);
          setLoading(true);
          await dispatch(createContract(req)).unwrap()
            .then((res) => {
              if (res.status) {
                // console.log("res", res);
                //setLoading(false);
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: res.message,
                  timer: 3000,
                  timerProgressBar: true,
                });
                // setLoading(false);
                AllQuote();
                return;
              }
              else {
                setLoading(false);
                if (res.message.includes("_____________")) {

                  Swal.fire({
                    icon: "warning",
                    title: "Warning..",
                    text: "Signature Tag Is Missing In The Document.",
                    timer: 3000,
                    timerProgressBar: true,
                  });
                  return;
                } else {

                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: res.message,
                    timer: 3000,
                    timerProgressBar: true,
                  })
                  return;
                }

              }
            }).catch((err) => {

              setLoading(false);
              console.log("err", err);
            })

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }
      });

    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "this contract is not sent yet",
        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
        timer: 3000,
      });
      return;
    }

  }

  const handleStopReminder = async (row) => {

    let stop_remainder_status = row.stop_remainder_status;
    let msg = "Stop";
    if (Number(row.stop_remainder_status) == 1) {
      stop_remainder_status = '0';
      msg = "Start";
    } else {
      stop_remainder_status = '1';
      msg = "Stop";
    }

    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${msg} reminder for this contract!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: msg + " Reminder",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, stop_remainder_status: stop_remainder_status, step: 5 };

        console.log("req", req);
        await dispatch(createContract(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: "Success!",
                text: `Reminder ${msg} successfully.`,

                icon: "success",
                showConfirmButton: true,
                confirmButtonText: "OK",
                timer: 3000,
              });
              AllQuote();
            } else {
              Swal.fire("Error!", "Something went wrong.", "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });

  }

  const columns = [
    {
      name: "Subject",
      selector: (row) => row?.subject == null || row?.subject == "" ? "-" : row?.subject,
      sortable: true,
    },
    {
      name: "Client",
      selector: (row) => cleanHtmlEntities(row?.Client?.client_name),
      sortable: true,
    },
    // {
    //   name: "Yearly Cost",
    //   selector: (row) => row?.yearly_cost,
    //   sortable: true,
    // },
     {
         name: "Created On",
         selector: row => row.createdAt,
         cell: row => DateConvertWithTime(row.createdAt),
         sortable: true,
         sortFunction: (a, b) =>
           new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
       },
    // {
    //   name: "Status",
    //   selector: (row) => Number(row?.contract_signed) === 1 ? "Contract Signed" :
    //     Number(row?.status) === 3 ? "Awaiting Signature" :
    //       Number(row?.step) === 4 ? "Pending for Signature" :
    //         Number(row?.step) !== 4 ? "In Progress" :
    //           "-",
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => {
        const contractSigned = Number(row?.contract_signed);
        const status = Number(row?.status);
        const step = Number(row?.step);

        if (contractSigned === 1) {
          return "Contract Signed";
        }

        if (status === 4) {
          return "Contract Declined";
        }

        if (status === 3) {
          //return "Awaiting Signature";
          return "Pending for Signature";
        }

        if (step === 4) {
          return "Pending for Signature";
        }


        if (step !== 4 && status !== 4) {
          if (Number(row?.higher_discount_status) === 0 && Number(row?.request_higher_discount_ongoing) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status_oneoff) === 0 && Number(row?.request_higher_discount_oneoff) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status) === 1 || Number(row?.higher_discount_status_oneoff) === 1) {
            return "Discount Approved";
          }
          else if (Number(row?.higher_discount_status) === 2 || Number(row?.higher_discount_status_oneoff) === 2) {
            return "Discount Rejected";
          }
          else {
            return "In Progress";
          }
        }

        return "-";
      },
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          {/* Edit Button (hidden if step is 4) */}
          {Number(row?.step) === 4 ? (
            ""
          ) : (
            <button
              className="btn fs-4 py-0 px-1"
              onClick={() => handleEdit(row)}
              title="Edit"
            >
              <i className="ri-edit-line" />
            </button>
          )}

          {/* Delete Button */}
          <button
            className="btn fs-4 py-0 px-1"
            onClick={() => handleDelete(row)}
            title="Delete"
          >
            <i className="bx bx-trash" />
          </button>

          {/* Download/Convert Button */}
          <button
            className="btn fs-4 py-0 px-1"
            onClick={() => handleConvert(row)}
            title="Download Document"
          >
            <i className="ri-download-2-line" />
          </button>

          {/* Resend Contract Button with appropriate icon */}
          {Number(row?.step) !== 4 ?
            "" :
            <>
              <button
                className="btn fs-4 py-0 px-1"
                onClick={(e) => handleResendContract(row)}
                title="Resend Contract"
              >
                <i className="ri-send-plane-line" />
              </button>



              <button
                className="btn fs-4 py-0 px-1"
                onClick={() => handleStopReminder(row)}
                title={Number(row.stop_remainder_status) === 1 ? "Start Reminder" : "Stop Reminder"}
              >
                {/* <i className="ri-timer-line" /> */}
                <i
                  className={`ri-timer-line ${Number(row.stop_remainder_status) === 1 ? "text-danger" : "text-success"
                    }`}
                />
              </button>

            </>
          }
        </div>
      ),
      sortable: true,
    },
  ];

  const handleConvert = async (row) => {

    if (!row?.pendingId || !row?.orignalId || !row?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please complete the contract first",

        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      });
      return;
    }

    let req = { agent_id: agent_id, id: row?.id };
    await dispatch(downloadContract(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          // console.log("response.data-->>",response)
          let access_token = response.data

          // let access_token = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjdMLXZ0VDNiN2pYc2I2cUZjLVBhNyJ9.eyJodHRwczovL3NpZ25lYXN5LmNvbS9lbWFpbCI6ImVzaWduQG5vbWlzbWFzb2x1dGlvbi5jby51ayIsImh0dHBzOi8vc2lnbmVhc3kuY29tL3VzZXJfaWQiOiI1MjUxNDc2IiwiaHR0cHM6Ly9zaWduZWFzeS5jb20vdGVzdF9tb2RlIjoiMSIsImlzcyI6Imh0dHBzOi8vYXV0aC5zaWduZWFzeS5jb20vIiwic3ViIjoidHdhZHRTZTN1ckU5cWZETUVlU0N0eHFudnk1dklzNHhAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vYXBpLWV4dC5zaWduZWFzeS5jb20vIiwiaWF0IjoxNzY1ODAyMTM4LCJleHAiOjE3NjgzOTQxMzgsInNjb3BlIjoidXNlcjpyZWFkIGZpbGVzOnJlYWQgb3JpZ2luYWw6cmVhZCBvcmlnaW5hbDpjcmVhdGUgb3JpZ2luYWw6dXBkYXRlIHNpZ25lZDpyZWFkIHNpZ25lZDpjcmVhdGUgc2lnbmVkOnVwZGF0ZSByczpyZWFkIHJzOmNyZWF0ZSByczp1cGRhdGUgcnM6c2lnbmluZ3VybCB0ZW1wbGF0ZTptYW5hZ2Ugd2ViaG9va3M6bWFuYWdlIiwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIiwiYXpwIjoidHdhZHRTZTN1ckU5cWZETUVlU0N0eHFudnk1dklzNHgifQ.RfQwxVSP-TV6zMN6Uo1NmhFvZOIg1dgAL3Cp0bV_1GKG9LxWT7bxGH6hirTlMfboOuIT-_vZ4qDt3LgdpF6B9RazaV-enFqEkV_EBdh5iTe26_t12vRWaI04X6AOnpIYd5D-I136tkUhw3-7cziIqxH48ATFtvL_ti8BTknPnhSkRYxJzaPN2wQYat2w4Bnfp7zFDIIBtEm5ixFlTfzoOEsU-UtIRif0yACej_KT9rrQcvhWJfq5QrLzkySCkks4Lao88_7_SO64XCRPkqjJLfmD3sJciN74qzwW9zsoS_RKXtgNaueNIKfu2p_t3tHmrwubCgEmpCsjd11EEkIi1A"

          setLoading(true);
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
            headers: {
              //Authorization: "Bearer " + row?.access_token,
              Authorization: "Bearer " + access_token,
            },
            responseType: "blob", // Important for binary PDF
          };

          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${row.subject || "document"}.pdf`;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              setLoading(false);

              console.log("Download error:", error);
            });


        } else {

        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",

        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const handleEdit = (row) => {
    nevigate("/admin/contracts/create-contract", { state: { row: row } });
  };

  const handleDelete = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this contract!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id , user_id : userDetails?.id };
        await dispatch(deleteContract(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              // Swal.fire({
              //   title: "Deleted!",
              //   text: "Your Contract has been deleted.",
              //   icon: "success",
              //   showConfirmButton: false,
              //   timer: 3000,
              // });
              // AllQuote();
               Swal.fire({
                title: "Deleted!",
                text: "Your Contract has been deleted.",
                icon: "success",
                showConfirmButton: false,
                timer: 3000,
              }).then(() => {
                AllQuote();
              });
            } else {
              Swal.fire("Error!", "Something went wrong.", "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your quote is safe :)", "error");
      }
    });
  };

  const handleExport = async () => {
    setLoading(true);
    let totalData = allQuoteData;

    let req = { agent_id: agent_id, page: 1, limit: 100000, search: "", filter: activeTab, contractTiles: contractTiles };

    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }

    await dispatch(getAllQuotes(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          totalData = response.data
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'No Data',
            text: 'No data to export!',
          });
          return
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'warning',
          title: 'No Data',
          text: 'No data to export!',
        });
        return
      });

    if (totalData.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      setLoading(false);
      return
    }

    // export format
    const exportData = totalData?.map((row) => ({
      "Subject": row?.subject,
      "Client": row?.Client?.client_name,
      "Created On": DateConvertWithTime(row?.createdAt),
      "Status": Number(row?.contract_signed) === 1 ? "Contract Signed" :
        Number(row?.status) === 3 ? "Awaiting Signature" :
          Number(row?.step) === 4 ? "Pending for Signature" :
            Number(row?.step) !== 4 ? "In Progress" :
              "-",
    }));
    setLoading(false);
    downloadCSV(exportData, "Contract Details.csv");
  };
  const downloadCSV = (data, filename) => {
    const csvRows = [];

    // headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    // rows
    data.forEach((row) => {
      const values = headers.map((h) => `"${row[h] || ""}"`);
      csvRows.push(values.join(","));
    });

    const csvString = csvRows.join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.click();
  };
  const handleExportPDF = async () => {
    setLoading(true);
    let req = {
      agent_id: agent_id,
      page: 1,
      limit: 100000,
      search: "",
      filter: activeTab,
      contractTiles: contractTiles,
    };

    if (
      activeTab === "custom-date" &&
      Array.isArray(range) &&
      range[0] &&
      range[1]
    ) {
      req.startDate = dayjs(range[0]).format("YYYY-MM-DD");
      req.endDate = dayjs(range[1]).format("YYYY-MM-DD");
    }

    const response = await dispatch(getAllQuotes(req)).unwrap();


    if (!response.status || response.data.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      setLoading(false);
      return;
    }



    const formattedData = response.data.map((row) => ({
      subject: row?.subject,
      client: row?.Client?.client_name,
      createdAt: DateConvertWithTime(row.createdAt),
      status:
        Number(row.contract_signed) === 1
          ? "Contract Signed"
          : Number(row.status) === 3
            ? "Awaiting Signature"
            : Number(row.step) === 4
              ? "Pending for Signature"
              : "In Progress",
    }));



    const res = await axios.post(
      Config.base_url + "export-contract-pdf",
      { data: formattedData },
      { responseType: "blob" }
    );

    setLoading(false);

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "Contract_Details.pdf";
    a.click();
  };
   const showPagination  = pageSize !== 0 && Math.ceil(totalRecords / pageSize)

  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/contracts/contracts-dashboard">
              <i className="bx bx-arrow-back text-pink"></i>
            </Link>{" "}
            All Contract
          </h4>
        </div>


        <div className="col-auto align-self-center">
          {allQuoteData?.length > 0 && (
            <>
              <button className="btn-outline-pink btn me-2" onClick={handleExportPDF}>
                <i className="ri-download-2-line"></i> Export PDF
              </button>

              <button className="btn-outline-pink btn me-2"
                onClick={handleExport}
              >
                <i className="ri-download-2-line"></i>  Export CSV
              </button>
            </>
          )}
          <Link
            to="/admin/contracts/create-contract"
            className="btn btn-pink"
            id="Dash_Date"
          >
            <span className="ay-name" id="Day_Name">
              Add New Contract
            </span>
          </Link>
        </div>
      </div>

      <section className="section dashboard">
        <div className="row">
          <data className="col-lg-3 datatable-search">
            <input
              type="text"
              className="search p-2 icon"
              placeholder="Search here"
              value={InputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </data>

          <div className="col-lg-3 filter-select mb-3 select_tab">
            <select
              onChange={handleTabChange}
              value={activeTab}
              className="form-select"
            >
              <option value="">All</option>
              <option value="current-month">Current Month</option>
              <option value="prev-month">Previous Month</option>
              <option value="current-quarter">Current Quarter</option>
              <option value="previous-quarter">Previous Quarter</option>
              <option value="current-calender-quarter">
                Current Calendar Year
              </option>
              <option value="prev-calender-year">Previous Calendar Year</option>
              <option value="custom-date">Custom Date</option>
            </select>
          </div>

          {activeTab === "custom-date" && (
            <div className=" d-flex gap-2  mb-3 col-lg-3 custom-datefilter">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DateRangePicker"]}>
                  <DatePicker.RangePicker
                    value={range}
                    onChange={setRange}
                    placeholder={['Start Date', 'End Date']}
                    format="DD/MM/YYYY"
                    className=""
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          )}

          <div className="col-lg-3 filter-select mb-3 select_tab">
            <select
              onChange={handleContratTiles}
              value={contractTiles}
              className="form-select"
            >
              <option value="">All</option>
              <option value="contract-created">Contract Created</option>
              <option value="contract-sent">Pending for Signature</option>
              <option value="contract-unsent">Contract Unsent</option>
              {/* <option value="contract-reviewed">Awaiting Signature</option> */}
              <option value="contract-signed">Contract Signed</option>
              <option value="contract-declined">Contract Declined</option>
            </select>
          </div>


        </div>

        <div className="table-main-div">
          <Datatable columns={columns} data={allQuoteData} filter={false} />
          {  allQuoteData.length > 0 ?
           <div>
            {
               showPagination > 1 && (
              <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize) || 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />

               )
            }
           
            <div className="mt-0">

              <select 
              // className="perpage-select" 
               className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
              value={pageSize} 
              onChange={handlePageSizeChange}>
                {/* <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option> */}
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={500}>500</option>
                <option value={0}>{"ALL"}</option>


              </select>
            </div>
          </div> : ""}
        </div>

      </section>
    </div>
  );
};

export default AllQuotes;
